import React, { useState, useEffect, useRef } from "react";
import Img from "gatsby-image";
import { useStaticQuery, graphql, Link } from "gatsby";
import classNames from "classnames";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import "./BusinessOverviewWidget.css";
const BusinessOverviewWidget = () => {
    const [imgClassFlag, setImgClassFlag] = useState(false);
    const ImageParentEl = useRef(null);
    const data = useStaticQuery(graphql`
        query BasketContainerQuery {
            mobileImage: file(relativePath: { eq: "basket-mob-uc.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(relativePath: { eq: "basket-desktop.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            animationImage: file(relativePath: { eq: "sales-anim.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    const sources = [
        data.desktopImage.childImageSharp.fluid,
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];

    useEffect(() => {
        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(
                entries => {
                    if (entries[0].intersectionRatio > 0) {
                        setImgClassFlag(() => true);
                    }
                },
                { threshold: 0.5 }
            );

            observer.observe(ImageParentEl.current);

            return () => {
                observer.disconnect();
            };
        }
    });

    return (
        <WidgetContainer stylesClass="business-overview">
            <div className="business-overview-container">
                <div className="business-overview-container__content-section">
                    <h2>For Business</h2>
                    <p>
                        Find the digital payment solution that fits your
                        business needs
                    </p>
                    <br />
                    <h3 className="">I want to:</h3>
                    <div className="business-overview-container__content-section__occup-container">
                        <Link
                            to="/business-solutions/switch/"
                            className="business-overview-container__content-section__occup-container__item"
                        >
                            <h4>Be on PhonePe Switch</h4>
                            <p>Get new users for your app</p>
                            <div className="hr"></div>
                        </Link>
                        <Link
                            to="/business-solutions/offline-merchant/"
                            className="business-overview-container__content-section__occup-container__item"
                        >
                            <h4>Accept payments at stores</h4>
                            <p>Help your business go cashless</p>
                            <div className="hr"></div>
                        </Link>
                        <Link
                            to="/business-solutions/online-merchant/"
                            className="business-overview-container__content-section__occup-container__item"
                        >
                            <h4>Accept online payments</h4>

                            <p>Set up easy payment solutions</p>
                            <div className="hr"></div>
                        </Link>
                        <Link
                            to="/business-solutions/merchant-advertisement/"
                            className="business-overview-container__content-section__occup-container__item"
                        >
                            <h4>Advertise on PhonePe</h4>

                            <p>Advertise &amp; let customers know about you</p>
                        </Link>
                    </div>
                </div>
                <div
                    className="business-overview-container__img-section"
                    ref={ImageParentEl}
                >
                    <Img fluid={sources} imgStyle={{ objectFit: "contain" }} />
                    <Img
                        fluid={data.animationImage.childImageSharp.fluid}
                        imgStyle={{ objectFit: "contain" }}
                        className={classNames(
                            "business-overview-container__img-section__img",
                            { "add-animation-bo": imgClassFlag }
                        )}
                        loading="eager"
                    />
                </div>
            </div>
        </WidgetContainer>
    );
};

export default BusinessOverviewWidget;
